export const ErrorMapperDnsConst = {
    40001: /* translationId */ 'ERRORS.40001',
    40004: /* translationId */ 'ERRORS.40004',
    40007: /* translationId */ 'ERRORS.40007'
};
